module.exports = __webpack_public_path__ + "static/media/box-person.ef1a7b28.svg";